// extracted by mini-css-extract-plugin
export var content = "_n0-1";
export var fullScreen = "_n0-0";